// Look con pin: pin prodotti, elenco prodotti e "Aggiungi il look al carrello"
if (!window.customElements.get('look-pins')) {
  class LookPins extends HTMLElement {
    // I pin sono blocchi figli: ognuno disegna puntino, card e riga dell'elenco.
    // Qui li disponiamo nei punti giusti e li numeriamo nell'ordine del tema.
    assemble() {
      const source = this.querySelector('.look-pins__source');
      if (!source) return;
      const media = this.querySelector('.look-pins__media');
      const rows = this.querySelector('.look-pins__rows');

      Array.from(source.querySelectorAll('[data-look-child]')).forEach((child, index) => {
        const n = index + 1;
        const pin = child.querySelector('[data-look-pin]');
        const card = child.querySelector('[data-look-card]');
        const row = child.querySelector('[data-look-row]');

        if (pin) {
          pin.dataset.pin = n;
          pin.querySelector('.look-pins__pin-dot').textContent = n;
          media.appendChild(pin);
        }
        if (card) {
          card.dataset.pin = n;
          media.appendChild(card);
        }
        if (row) {
          row.dataset.pin = n;
          const num = row.querySelector('.look-pins__num');
          if (num) num.textContent = n;
          if (rows) rows.appendChild(row);
        }
      });

      source.remove();
    }

    connectedCallback() {
      // Il tema editor puo spostare o ricollegare l'elemento piu volte (per esempio quando si aggiunge
      // un'altra sezione): la costruzione dei contenuti e dei listener dell'elemento avviene una volta sola.
      if (!this.lookReady) {
        this.lookReady = true;
        this.onClick = this.onClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onOver = this.onOver.bind(this);
        this.onOut = this.onOut.bind(this);
        this.onResize = () => (this.alwaysOpen ? this.refreshCards() : this.closeCards());
        this.layoutPins = this.layoutPins.bind(this);

        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
        this.addEventListener('mouseover', this.onOver);
        this.addEventListener('mouseout', this.onOut);

        this.pinHelper = new URLSearchParams(window.location.search).get('pin') === '1';
        this.assemble();
        this.bindHover();
        this.querySelectorAll('.look-pins__card img').forEach((img) => img.addEventListener('load', () => this.refreshCards()));
        this.querySelectorAll('.look-pins__row').forEach((row) => this.buildInline(row));
      }

      // listener globali: aggiunti a ogni collegamento e rimossi a ogni scollegamento
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);
      window.addEventListener('resize', this.onResize);
      this.setupLayout();
      this.refresh();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
      window.removeEventListener('resize', this.onResize);
      clearTimeout(this.closeTimer);
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    }

    // ---- Card dei pin ----
    get canHover() {
      return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

    openCard(pinNumber) {
      clearTimeout(this.closeTimer);
      this.closeCards();
      const pin = this.querySelector(`.look-pins__pin[data-pin="${pinNumber}"]`);
      const card = this.querySelector(`.look-pins__card[data-pin="${pinNumber}"]`);
      if (!pin || !card) return;
      card.style.visibility = 'hidden';
      card.hidden = false;
      this.positionCard(pin, card);
      card.style.visibility = '';
      pin.setAttribute('aria-expanded', 'true');
      this.setHighlight(pinNumber, true);
    }

    get alwaysOpen() {
      if (this.dataset.alwaysOpen !== 'true') return false;
      const mobile = window.matchMedia('(max-width: 999px)').matches;
      return !mobile || this.dataset.alwaysOpenMobile === 'true';
    }

    overlaps(a, b, margin = 6) {
      return a.left < b.left + b.width + margin && a.left + a.width + margin > b.left &&
        a.top < b.top + b.height + margin && a.top + a.height + margin > b.top;
    }

    positionCard(pin, card, avoid = []) {
      const media = this.querySelector('.look-pins__media').getBoundingClientRect();
      const pinRect = pin.getBoundingClientRect();
      const cw = card.offsetWidth;
      const ch = card.offsetHeight;
      const gap = 14;
      const px = pinRect.left - media.left + pinRect.width / 2;
      const py = pinRect.top - media.top + pinRect.height / 2;
      const half = pinRect.width / 2;

      const spaceRight = media.width - px - half - gap;
      const spaceLeft = px - half - gap;
      const preferred = spaceRight >= cw || spaceRight >= spaceLeft ? 'right' : 'left';
      const sides = preferred === 'right' ? ['right', 'left'] : ['left', 'right'];
      const shifts = avoid.length ? [0, ch * 0.55, -ch * 0.55, ch * 1.1, -ch * 1.1] : [0];

      const candidates = [];
      sides.forEach((side) => {
        shifts.forEach((shift) => {
          let left = side === 'right' ? px + half + gap : px - half - gap - cw;
          left = Math.max(4, Math.min(left, media.width - cw - 4));
          let top = py - ch / 2 + shift;
          top = Math.max(4, Math.min(top, media.height - ch - 4));
          candidates.push({ side, left, top, width: cw, height: ch });
        });
      });

      const choice = candidates.find((c) => !avoid.some((other) => this.overlaps(c, other))) || candidates[0];

      card.style.left = `${choice.left}px`;
      card.style.top = `${choice.top}px`;
      card.dataset.side = choice.side;
      card.style.setProperty('--arrow-y', `${Math.max(14, Math.min(py - choice.top, ch - 14))}px`);
      return choice;
    }

    // Modalita "sempre aperte": mostra tutte le nuvolette evitando che si coprano
    refreshCards() {
      if (!this.alwaysOpen) return;
      const placed = [];
      this.querySelectorAll('.look-pins__pin').forEach((pin) => {
        const card = this.querySelector(`.look-pins__card[data-pin="${pin.dataset.pin}"]`);
        if (!card) return;
        if (pin.style.display === 'none' || card.dataset.dismissed === '1') {
          card.hidden = true;
          pin.setAttribute('aria-expanded', 'false');
          return;
        }
        card.style.visibility = 'hidden';
        card.hidden = false;
        placed.push(this.positionCard(pin, card, placed));
        card.style.visibility = '';
        pin.setAttribute('aria-expanded', 'true');
      });
    }

    bringFront(pinNumber) {
      this.querySelectorAll('.look-pins__card').forEach((card) => card.classList.toggle('is-front', card.dataset.pin === String(pinNumber)));
    }

    scheduleClose() {
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => this.closeCards(), 180);
    }

    closeCards() {
      this.querySelectorAll('.look-pins__card').forEach((card) => { card.hidden = true; });
      this.querySelectorAll('.look-pins__pin').forEach((pin) => pin.setAttribute('aria-expanded', 'false'));
      this.querySelectorAll('.is-highlight').forEach((el) => el.classList.remove('is-highlight'));
    }

    setHighlight(pinNumber, on) {
      this.querySelectorAll(`[data-pin="${pinNumber}"]`).forEach((el) => {
        if (el.classList.contains('look-pins__pin') || el.classList.contains('look-pins__row')) {
          el.classList.toggle('is-highlight', on);
        }
      });
    }

    bindHover() {
      this.querySelectorAll('.look-pins__pin').forEach((pin) => {
        pin.addEventListener('pointerenter', (event) => {
          if (this.alwaysOpen) { this.bringFront(pin.dataset.pin); return; }
          if (event.pointerType === 'mouse' && this.canHover) this.openCard(pin.dataset.pin);
        });
        pin.addEventListener('pointerleave', (event) => {
          if (this.alwaysOpen) return;
          if (event.pointerType === 'mouse' && this.canHover) this.scheduleClose();
        });
      });
      this.querySelectorAll('.look-pins__card').forEach((card) => {
        card.addEventListener('pointerenter', (event) => {
          if (this.alwaysOpen) { this.bringFront(card.dataset.pin); return; }
          if (event.pointerType === 'mouse') clearTimeout(this.closeTimer);
        });
        card.addEventListener('pointerleave', (event) => {
          if (this.alwaysOpen) return;
          if (event.pointerType === 'mouse' && this.canHover) this.scheduleClose();
        });
      });
    }

    onOver(event) {
      const target = event.target.closest('.look-pins__row');
      if (target) this.setHighlight(target.dataset.pin, true);
    }

    onOut(event) {
      const target = event.target.closest('.look-pins__row');
      if (!target) return;
      const card = this.querySelector(`.look-pins__card[data-pin="${target.dataset.pin}"]`);
      if (card && !card.hidden) return;
      this.setHighlight(target.dataset.pin, false);
    }

    onDocumentClick(event) {
      if (!this.alwaysOpen && !this.contains(event.target)) this.closeCards();
    }

    onKeydown(event) {
      if (event.key === 'Escape' && !this.alwaysOpen) this.closeCards();
    }

    onClick(event) {
      const pin = event.target.closest('.look-pins__pin');
      if (pin && this.alwaysOpen) {
        const card = this.querySelector(`.look-pins__card[data-pin="${pin.dataset.pin}"]`);
        if (card) {
          card.dataset.dismissed = card.hidden ? '' : '1';
          this.refreshCards();
          this.bringFront(pin.dataset.pin);
        }
        return;
      }
      if (pin) {
        const card = this.querySelector(`.look-pins__card[data-pin="${pin.dataset.pin}"]`);
        if (card && !card.hidden && !this.canHover) this.closeCards();
        else this.openCard(pin.dataset.pin);
        return;
      }

      const pill = event.target.closest('.look-pins__pill');
      if (pill) {
        this.onPill(pill);
        return;
      }

      if (event.target.closest('[data-look-add-all]')) {
        this.addAll(event.target.closest('[data-look-add-all]'));
        return;
      }

      // aiuto coordinate: clic sull'immagine (solo con ?pin=1)
      if (this.pinHelper && event.target.closest('.look-pins__media') && !event.target.closest('.look-pins__card')) {
        this.showHelper(event);
      }
    }

    onChange(event) {
      if (event.target.closest('.look-pins__variant, .look-pins__check')) this.refresh();
    }

    // ---- Posizione dei pin sulla foto (anche quando e ritagliata) ----
    setupLayout() {
      const frame = this.querySelector('.look-pins__frame');
      const img = this.querySelector('.look-pins__image');
      if (!frame) return;
      if (img && img.tagName === 'IMG' && !img.complete) img.addEventListener('load', this.layoutPins, { once: true });
      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(() => this.layoutPins());
        this.resizeObserver.observe(frame);
      }
      this.layoutPins();
    }

    // Restituisce dove sta la foto originale dentro la cornice (identita se non e ritagliata)
    mapping() {
      const frame = this.querySelector('.look-pins__frame');
      const img = this.querySelector('.look-pins__image');
      const box = frame ? frame.getBoundingClientRect() : { width: 0, height: 0 };
      const identity = { offX: 0, offY: 0, rw: box.width, rh: box.height, cropped: false };
      if (!img || img.tagName !== 'IMG' || !img.naturalWidth) return identity;

      const style = getComputedStyle(img);
      if (style.objectFit !== 'cover') return identity;

      const scale = Math.max(box.width / img.naturalWidth, box.height / img.naturalHeight);
      const rw = img.naturalWidth * scale;
      const rh = img.naturalHeight * scale;
      const [fx, fy] = style.objectPosition.split(' ').map((v) => (parseFloat(v) || 0) / 100);
      return { offX: (box.width - rw) * fx, offY: (box.height - rh) * fy, rw, rh, cropped: true, boxW: box.width, boxH: box.height };
    }

    layoutPins() {
      const map = this.mapping();
      this.querySelectorAll('.look-pins__pin').forEach((pin) => {
        if (!map.cropped) {
          pin.style.left = '';
          pin.style.top = '';
          pin.style.display = '';
          return;
        }
        const x = map.offX + (Number(pin.dataset.x) / 100) * map.rw;
        const y = map.offY + (Number(pin.dataset.y) / 100) * map.rh;
        const hidden = x < 0 || y < 0 || x > map.boxW || y > map.boxH;
        pin.style.display = hidden ? 'none' : '';
        pin.style.left = `${x}px`;
        pin.style.top = `${y}px`;
      });
      this.refreshCards();
    }

    // ---- Coordinate ----
    showHelper(event) {
      const media = this.querySelector('.look-pins__media');
      const rect = media.getBoundingClientRect();
      const map = this.mapping();
      const clickX = event.clientX - rect.left;
      const clickY = event.clientY - rect.top;
      const x = Math.round(((clickX - map.offX) / map.rw) * 100);
      const y = Math.round(((clickY - map.offY) / map.rh) * 100);

      this.querySelector('.look-pins__helper')?.remove();
      const helper = document.createElement('div');
      helper.className = 'look-pins__helper';
      helper.style.left = `${clickX}px`;
      helper.style.top = `${clickY}px`;
      helper.textContent = `Orizzontale: ${x}  ·  Verticale: ${y}`;
      media.appendChild(helper);
    }

    // ---- Elenco e carrello ----
    // Stessa regola della scheda prodotto: preordine attivo solo se il flag e acceso
    // e "adesso" cade dentro la finestra inizio-fine
    isPreorderNow(flag, start, end) {
      const now = Math.floor(Date.now() / 1000);
      const s = Number(start);
      const e = Number(end);
      return !!flag && s > 0 && e > 0 && e > s && now >= s && now <= e;
    }

    rowVariant(row) {
      const field = row.querySelector('.look-pins__variant');
      if (!field || !field.value) return null;
      const source = field.tagName === 'SELECT' ? field.selectedOptions[0] : field;
      if (!source) return null;
      const d = source.dataset;
      const active = d.preorderActive !== undefined
        ? d.preorderActive === 'true'
        : this.isPreorderNow(d.preorder === 'true', d.preorderStart, d.preorderEnd);
      return {
        id: Number(field.value),
        price: Number(d.price) || 0,
        preorder: active,
        text: d.preorderText || ''
      };
    }

    showPreorderNote(row, variant) {
      const note = row.querySelector('.look-pins__preorder-note');
      if (!note) return;
      if (variant && variant.preorder) {
        note.textContent = `${this.dataset.msgPreorder || ''} ${variant.text || ''}`.trim();
        note.hidden = false;
      } else {
        note.textContent = '';
        note.hidden = true;
      }
    }

    syncRow(row) {
      const variant = this.rowVariant(row);
      const check = row.querySelector('.look-pins__check');
      if (!check) return { row, variant, included: false, selectable: false };

      const needsChoice = !variant && !!row.querySelector('[data-look-inline]');
      this.showPreorderNote(row, variant);

      if (row.classList.contains('is-soldout')) {
        check.checked = false;
        check.disabled = true;
      } else if (needsChoice) {
        if (!check.disabled) check.dataset.autoOff = '1';
        check.checked = false;
        check.disabled = true;
        row.classList.toggle('is-unchecked', true);
        return { row, variant: null, included: false, selectable: true };
      } else if (check.disabled && check.dataset.autoOff === '1') {
        check.disabled = false;
        check.checked = true;
        delete check.dataset.autoOff;
      }

      row.classList.toggle('is-unchecked', !check.checked);
      return { row, variant, included: !!variant && check.checked && !check.disabled, selectable: !check.disabled };
    }

    rows() {
      return Array.from(this.querySelectorAll('.look-pins__row')).map((row) => this.syncRow(row));
    }

    // ---- Scelta colore / taglia (nella riga) ----
    buildInline(row) {
      const holder = row.querySelector('[data-look-inline]');
      const dataEl = row.querySelector('.look-pins__data');
      if (!holder || !dataEl) return;

      if (holder.dataset.built === '1') return;
      holder.dataset.built = '1';
      holder.textContent = '';

      const data = JSON.parse(dataEl.textContent);
      row.lookData = data;
      row.lookSelected = data.options.map((option) => (option.values.length === 1 ? option.values[0] : null));

      data.options.forEach((option, i) => {
        // un'opzione con un solo valore (per esempio un solo colore) e gia scelta: non va mostrata
        if (option.values.length === 1) return;
        const set = document.createElement('fieldset');
        set.className = 'look-pins__option';
        const legend = document.createElement('legend');
        legend.textContent = option.name;
        set.appendChild(legend);
        const pills = document.createElement('div');
        pills.className = 'look-pins__pills';
        option.values.forEach((value) => {
          const pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'look-pins__pill';
          pill.dataset.opt = i;
          pill.dataset.val = value;
          pill.textContent = value;
          pills.appendChild(pill);
        });
        set.appendChild(pills);
        holder.appendChild(set);
      });

      this.updateOptions(row, false);
    }

    onPill(pill) {
      const row = pill.closest('.look-pins__row');
      if (pill.disabled || !row.lookSelected) return;
      const i = Number(pill.dataset.opt);
      row.lookSelected[i] = row.lookSelected[i] === pill.dataset.val ? null : pill.dataset.val;
      this.updateOptions(row, true);
    }

    matchingVariant(row) {
      const selected = row.lookSelected;
      if (selected.some((v) => v === null)) return null;
      return row.lookData.variants.find((v) => v.options.every((o, i) => o === selected[i])) || null;
    }

    updateOptions(row, fromUser) {
      const { variants } = row.lookData;
      const selected = row.lookSelected;

      row.querySelectorAll('.look-pins__pill').forEach((pill) => {
        const i = Number(pill.dataset.opt);
        const value = pill.dataset.val;
        const possible = variants.some((v) =>
          v.available && v.options[i] === value && v.options.every((o, j) => j === i || selected[j] === null || selected[j] === o)
        );
        pill.disabled = !possible;
        pill.setAttribute('aria-pressed', selected[i] === value ? 'true' : 'false');
        pill.classList.toggle('is-selected', selected[i] === value);
      });

      const variant = this.matchingVariant(row);
      const usable = !!variant && variant.available;
      const preorderNow = !!variant && this.isPreorderNow(variant.preorder, variant.preorderStart, variant.preorderEnd);
      const field = row.querySelector('.look-pins__variant');
      const check = row.querySelector('.look-pins__check');

      if (usable) {
        const changed = field.value !== String(variant.id);
        field.value = variant.id;
        field.dataset.price = variant.price;
        field.dataset.preorderActive = preorderNow ? 'true' : 'false';
        field.dataset.preorderText = variant.preorderText || '';
        if (check && (changed || check.disabled)) {
          check.disabled = false;
          check.checked = true;
          delete check.dataset.autoOff;
        }
        this.showPreorderNote(row, { preorder: preorderNow, text: variant.preorderText || '' });
      } else {
        field.value = '';
        field.dataset.price = '0';
        field.dataset.preorderActive = 'false';
        this.showPreorderNote(row, null);
      }

      if (fromUser) this.refresh();
    }

    format(cents) {
      const currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR';
      const locale = this.dataset.locale || document.documentElement.lang || 'it';
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }

    refresh() {
      const all = this.rows();
      const included = all.filter((r) => r.included);
      const selectable = all.filter((r) => r.selectable);
      const everything = included.length > 0 && included.length === selectable.length;

      const totalEl = this.querySelector('[data-look-total]');
      if (totalEl) totalEl.textContent = this.format(included.reduce((sum, r) => sum + r.variant.price, 0));

      const totalLabel = this.querySelector('[data-look-total-label]');
      if (totalLabel) totalLabel.textContent = everything ? this.dataset.labelTotalAll : this.dataset.labelTotalSome;

      const button = this.querySelector('[data-look-add-all]');
      if (button) {
        button.textContent = everything
          ? this.dataset.labelAddAll
          : (this.dataset.labelAddSome || '').replace('{n}', included.length);
        button.disabled = included.length === 0;
      }
    }

    setMessage(text) {
      const el = this.querySelector('[data-look-message]');
      if (el) el.textContent = text || '';
    }

    async addAll(button) {
      const included = this.rows().filter((r) => r.included);

      if (included.length === 0) {
        this.setMessage(this.dataset.msgNone);
        return;
      }

      this.setMessage('');
      button.setAttribute('aria-busy', 'true');
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

      let response;
      let json;
      try {
        response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            items: included.map((r) => {
              const item = { id: r.variant.id, quantity: 1 };
              if (r.variant.preorder && r.variant.text) item.properties = { 'PRE-ORDINE': r.variant.text };
              return item;
            }),
            sections: sectionsToBundle.join(','),
            sections_url: window.location.pathname
          })
        });
        json = await response.json();
      } catch (e) {
        response = { ok: false };
        json = { description: '' };
      }

      button.removeAttribute('aria-busy');
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

      if (!response.ok) {
        this.setMessage(json.description || json.message || 'Errore');
        return;
      }

      this.setMessage(`${included.length} ${this.dataset.msgAdded}`);

      const settings = window.themeVariables && window.themeVariables.settings;
      if (settings && (settings.cartType === 'page' || settings.pageType === 'cart')) {
        window.location.href = `${Shopify.routes.root}cart`;
        return;
      }

      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      cartContent.sections = json.sections;
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', cart: cartContent }
      }));
    }
  }

  window.customElements.define('look-pins', LookPins);
}
